import Reflux from 'reflux';
import MessageActions from 'actions/Message';

export default Reflux.createStore({
  listenables: [MessageActions],
  data: {
    message: ''
  },
  getInitialState() {
    return this.data;
  },
  init() {},
  onNotify(message) {
    this.data.message = message;
    this.trigger(this.data);
  },
  get() {
    var message = this.data.message;
    this.data.message = '';
    return message;
  }
});



// WEBPACK FOOTER //
// ./src/js/stores/Message.js